import { render, staticRenderFns } from "./uploadDialog.vue?vue&type=template&id=45865b3c"
import script from "./uploadDialog.vue?vue&type=script&lang=js"
export * from "./uploadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports